module.exports = __webpack_public_path__ + "static/media/Attachment 2 - Supporting Information Required.97f44307.pdf";